
import React, { FC } from 'react';
import Button from "../../../../shared/ui/button/Button";
import arrow from "../../../../assets/img/arrow_forward.svg";
import spark from "../../../../assets/img/spark.svg";
import s from './ActionsButton.module.css'
interface ActionButtonsProps {
    step: number;
    totalSteps: number;
    isStepCompleted: () => boolean;
    handleSetStep: () => void;
    handleGenerateScript: () => void;
}

const ActionButtons: FC<ActionButtonsProps> = ({
                                                   step,
                                                   totalSteps,
                                                   isStepCompleted,
                                                   handleSetStep,
                                                   handleGenerateScript,
                                               }) => {


    return (
        <div className={s.container} >

            {step >= 1 && step < totalSteps - 1 && isStepCompleted()&&(
                <Button

                    text="Continue"
                    icon={arrow}
                    iconPosition="right"
                    onClick={handleSetStep}
                />

            )}

            {step === 4 && (
                <Button

                    text="Generate Post"
                    icon={spark}
                    iconPosition="left"
                    onClick={handleGenerateScript}
                />
            )}
        </div>
    );
};

export default ActionButtons;
